export const environment = {
  production: true,
  // apiEndPoint:"http://192.168.29.253:8082/astrologyapp/",

  // apiEndPoint:"https://testapi.astroapp.live:8084/astrologyapp/",
  // apiEndPoint:"http://localhost:8082/astrologyapp/",
  apiEndPoint: "https://testapi.astroapp.live:8084/astrologyapp/",
  firebase: {
    apiKey: "AIzaSyC0dnfywlm2gfKMNBkx7eAZrxGucNKR82A",
    authDomain: "astroapp-44f62.firebaseapp.com",
    projectId: "astroapp-44f62",
    storageBucket: "astroapp-44f62.appspot.com",
    messagingSenderId: "711485441025",
    appId: "1:711485441025:web:88bf8f16fad76624752c00",
    measurementId: "G-CGY4J3XVL8",
    vapidKey: "BFJqjJ24zXYZfy9MrtaBem-MpHFabekNzy8WXQKwSU9lLbRx4R160xX3m-FWBcDfiUqbjX8AgYcskbFDPg0Kurg"
  }
};